import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/header'

import 'semantic-ui-css/semantic.min.css';

import './default.css'
import './pandoc-code-highlight.css'
import './index.css'
const Layout = ({ children, data }) => (
  <div>

<Helmet>
                  <meta charSet="utf-8" />
                  <title>Yodal Developer</title>
              </Helmet>
    {children()}
</div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js